'use client';
import React, { useEffect, useState } from 'react';
import { useFetch } from '../../../context/FetchProvider';
import { BookReferenceProps } from '@osmosis/shared/types/learndb/learnData';

import ExternalReferencesBlockView from './ExternalReferencesBlockView';
import { useUserContext } from '../../../context/UserContext';
import { CommonLearnBlockProps } from './LearnBlock';

const CURRENT_BOOK = 'f21';
const DEPRECATED_BOOKS = ['f14', 'f15', 'f16', 'f17'];

type Props = {
  references: BookReferenceProps[];
} & CommonLearnBlockProps;

type CurriculumRes = {
  curriculum: {
    schedule: {
      books: {
        fa: string;
      };
    };
  };
};

/**
 * .
 */
export default function ExternalReferencesBlock(props: Props): JSX.Element {
  const { references, contentOnly } = props;
  const { user } = useUserContext();
  const { post, get } = useFetch();

  const [selectedReference, setSelectedReference] =
    useState<BookReferenceProps>(references[0]);

  /**
   * .
   */
  const handleUpdateVersion = async (id: string): Promise<void> => {
    // Update the user's settings
    await post('/setFAVersion', {
      edition: id,
    });
  };

  /**
   * .
   */
  const handleSelectReference = (reference: BookReferenceProps): void => {
    setSelectedReference(reference);

    void handleUpdateVersion(reference.bookID);
  };

  useEffect(() => {
    // Pull user settings
    void (async () => {
      if (user) {
        const { data } = await get<CurriculumRes>('/data/user/curriculum');
        if (data?.curriculum) {
          const bookId = data.curriculum?.schedule?.books?.fa;

          if (bookId && bookId !== selectedReference.bookID) {
            let book;
            // Set to current book if user has deprecated book
            if (DEPRECATED_BOOKS.includes(bookId)) {
              void handleUpdateVersion(CURRENT_BOOK);
              book = references.find((r) => r.bookID === CURRENT_BOOK);
            } else {
              // Update to user's preference
              book = references.find((r) => r.bookID === bookId);
            }

            if (book) setSelectedReference(book);
          }
        }
      }
    })();
  }, []);

  return (
    <ExternalReferencesBlockView
      references={references}
      onSelectReference={handleSelectReference}
      selectedReference={selectedReference}
      contentOnly={contentOnly}
    />
  );
}
